<template>
  <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item>
        <el-select style="width: 100%;" v-model="companyId" filterable clearable placeholder="请选择所属公司">
          <el-option
            v-for="item in companys"
            :key="item.Id"
            :value="item.Id"
            :label="item.CompanyName"
          >
            <span style="float: left">{{ item.CompanyName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select style="width: 150px;" v-model="busLinesId" filterable clearable placeholder="请选择归属线路">
          <el-option
            v-for="item in busLiness"
            :key="item.Id"
            :value="item.Id"
            :label="item.LineChineseName"
          >
            <span style="float: left">{{ item.LineChineseName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="licensePlateNumber" style="width: 150px;" placeholder="请输入车牌号码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="terminalsId" style="width: 150px;" placeholder="请输入终端Id"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="simId" placeholder="请输入SimId"></el-input>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.IsHide" @click="callFunc(item)">{{item.name}}</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
import { getCompanyListPage,getBusLinesListPage } from "../../api/api";

export default {
  name: "VehiclesToolbar",
  data() {
    return {
      companys: [], //企业列表
      busLiness: [], //线路列表
      companyId:"", //企业ID
      busLinesId:"", //线路ID
      licensePlateNumber:"", //车牌号码
      terminalsId:"", //终端Id
      simId: "" //simId
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      item.companyId = this.companyId;
      item.busLinesId = this.busLinesId;
      item.licensePlateNumber = this.licensePlateNumber;
      item.terminalsId = this.terminalsId;
      item.simId = this.simId;
      this.$emit("callFunction", item); //将值传给父组件
    }
  },
  mounted() {
    let para = {
      companyName: "",
      operatingStatus: "true",
      enabled: "true",
      page: 1,
      pageSize: 100
    };
    getCompanyListPage(para).then(res => {
      this.companys = res.data.response.data;
    });

    let pageSizePara = {
      pageSize: 100
    };
    getBusLinesListPage(pageSizePara).then(res => {
      this.busLiness = res.data.response.data;
    });
  }
};
</script>